import { render } from "./NotFound.vue?vue&type=template&id=18430fe2"
const script = {}

import exportComponent from "C:\\vue\\evangelio-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__